import React from "react"

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 125"
    enableBackground="new 0 0 100 100"
    xmlSpace="preserve"
  >
    <g>
      <path d="M54.2,44.8l1.9-10.5H52l-1.9,10.5H48L50,34.4h-4.1L44,44.8h-9.7L37.4,88h25.2l3-43.2H54.2z M58.8,84H41.2l-2.6-35.2h22.7   L58.8,84z" />
      <polygon points="69.1,95 30.9,95 26.8,34.4 30.7,34.4 34.6,91 65.4,91 69.3,34.4 73.2,34.4  " />
      <polygon points="80.3,38.8 76.3,38.8 76.3,32 23.8,32 23.8,38.8 19.8,38.8 19.8,28 80.3,28  " />
      <polygon points="61.2,5.5 57.6,25.6 53.6,25.6 56.5,9.5 54.5,9.5 51.5,25.6 47.5,25.6 51.1,5.5  " />
      <circle cx="45.3" cy="79.7" r="3.3" />
      <circle cx="52.7" cy="79.7" r="3.3" />
      <circle cx="47.1" cy="72.6" r="3.3" />
      <circle cx="55" cy="72.6" r="3.3" />
    </g>
    <text
      x="0"
      y="115"
      fill="#000000"
      fontSize="5px"
      fontWeight="bold"
      fontFamily="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
    >
      Milk Tea Icon created by Dan Hetteix
    </text>
    <text
      x="0"
      y="120"
      fill="#000000"
      fontSize="5px"
      fontWeight="bold"
      fontFamily="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
    >
      from the Noun Project
    </text>
  </svg>
)



// WEBPACK FOOTER //
// ./src/img/milktea.js